<template>
	<div class="format-selector">
		<div class="pa-block">
			<h3 class="selector-title">Choisissez votre offre</h3>
			<div class="pa-block__inner">
				<!-- PROFLIB / PRINT -->
				<div class="format-selector__offer">
					<div
						class="pa-block__col-container"
						v-if="currentProfil == 'proflib' && currentMode == 'print_web'"
					>
						<div
							class="pa-block__col"
							:class="{
								inactive: format != 'simple',
								active: format == 'simple',
							}"
						>
							<label for="format-simple">
								<img
									src="/wp-content/themes/id/images/classified/illustrations/illustation-simple.png"
									width="56"
									height="70"
									alt=""
								/>
								<div class="label__container">
									<strong>Annonce simple</strong>
									<small>5 lignes</small>
									<ul>
										<li>175 caractères maximum</li>
									</ul>
									<div class="price">
										<span>
											{{
												price(
													currentProfil,
													currentCategory,
													currentMode,
													"simple"
												)
											}}
											€
											<small>TTC</small>
										</span>
									</div>
								</div>
								<!-- .label__container -->
								<input
									type="radio"
									name="format"
									id="format-simple"
									value="simple"
									v-model="format"
								/>
							</label>
						</div>
						<!-- .pa-block__col -->
						<div
							class="pa-block__col"
							:class="{ inactive: format != '1/9', active: format == '1/9' }"
						>
							<label for="format-1/9">
								<img
									src="/wp-content/themes/id/images/classified/illustrations/illustation-1-9.png"
									width="56"
									height="70"
									alt=""
								/>
								<div class="label__container">
									<strong>1/9e de page</strong>
									<small>57 x 75 mm</small>
									<ul>
										<li>300 caractères maximum</li>
										<li>1 photo possible</li>
									</ul>
									<div class="price">
										<span>
											{{
												price(
													currentProfil,
													currentCategory,
													currentMode,
													"1/9"
												)
											}}
											€
											<small>TTC</small>
										</span>
									</div>
								</div>
								<!-- .label__container -->
								<input
									type="radio"
									name="format"
									id="format-1/9"
									value="1/9"
									v-model="format"
								/>
							</label>
						</div>
						<!-- .pa-block__col -->
						<div
							class="pa-block__col"
							:class="{ inactive: format != '2/9', active: format == '2/9' }"
						>
							<label for="format-2/9">
								<img
									src="/wp-content/themes/id/images/classified/illustrations/illustation-2-9.png"
									width="56"
									height="70"
									alt=""
								/>
								<div class="label__container">
									<strong>2/9e de page</strong>
									<small>57 x 140 mm</small>
									<ul>
										<li>600 caractères maximum</li>
										<li>2 photos possibles</li>
									</ul>
									<div class="price">
										<span>
											{{
												price(
													currentProfil,
													currentCategory,
													currentMode,
													"2/9"
												)
											}}
											€
											<small>TTC</small>
										</span>
									</div>
								</div>
								<!-- .label__container -->
								<input
									type="radio"
									name="format"
									id="format-2/9"
									value="2/9"
									v-model="format"
								/>
							</label>
						</div>
						<!-- .pa-block__col -->
					</div>
					<!-- .pa-block__col-container -->
					<!-- RECRUITER / PRINT -->
					<div
						class="pa-block__col-container pa-block__col-container--custom"
						v-if="currentProfil == 'recruiter' && currentMode == 'print_web'"
					>
						<div
							class="pa-block__col"
							:class="{ inactive: format != '1/9', active: format == '1/9' }"
						>
							<label for="format-1/9">
								<img
									src="/wp-content/themes/id/images/classified/illustrations/illustation-1-9.png"
									width="56"
									height="70"
									alt=""
								/>
								<div class="label__container">
									<strong>1/9e page</strong>
									<small>57 x 75 mm</small>
									<ul>
										<li>300 caractères maximum</li>
										<li>1 photo possible</li>
									</ul>
									<div class="price">
										<span>
											{{
												price(
													currentProfil,
													currentCategory,
													currentMode,
													"1/9"
												)
											}}
											€
											<small>TTC</small>
										</span>
									</div>
								</div>
								<!-- .label__container -->
								<input
									type="radio"
									name="format"
									id="format-1/9"
									value="1/9"
									v-model="format"
								/>
							</label>
						</div>
						<!-- .pa-block__col -->
						<div
							class="pa-block__col"
							:class="{ inactive: format != '2/9', active: format == '2/9' }"
						>
							<label for="format-2/9">
								<img
									src="/wp-content/themes/id/images/classified/illustrations/illustation-2-9.png"
									width="56"
									height="70"
									alt=""
								/>
								<div class="label__container">
									<strong>2/9e de page</strong>
									<small>57 x 140 mm</small>
									<ul>
										<li>600 caractères maximum</li>
										<li>2 photos possibles</li>
									</ul>
									<div class="price">
										<span>
											{{
												price(
													currentProfil,
													currentCategory,
													currentMode,
													"2/9"
												)
											}}
											€
											<small>TTC</small>
										</span>
									</div>
								</div>
								<!-- .label__container -->
								<input
									type="radio"
									name="format"
									id="format-2/9"
									value="2/9"
									v-model="format"
								/>
							</label>
						</div>
						<!-- .pa-block__col -->
						<div
							class="pa-block__col"
							:class="{ inactive: format != '3/9', active: format == '3/9' }"
						>
							<label for="format-3/9">
								<img
									src="/wp-content/themes/id/images/classified/illustrations/illustation-3-9.png"
									width="56"
									height="70"
									alt=""
								/>
								<div class="label__container">
									<strong>3/9e de page</strong>
									<small>180 x 75 mm</small>
									<ul>
										<li>600 caractères maximum</li>
										<li>3 photos possibles</li>
									</ul>
									<div class="price">
										<span>
											{{
												price(
													currentProfil,
													currentCategory,
													currentMode,
													"3/9"
												)
											}}
											€
											<small>TTC</small>
										</span>
									</div>
								</div>
								<!-- .label__container -->
								<input
									type="radio"
									name="format"
									id="format-3/9"
									value="3/9"
									v-model="format"
								/>
							</label>
						</div>
						<!-- .pa-block__col -->
						<div
							class="pa-block__col"
							:class="{ inactive: format != '6/9', active: format == '6/9' }"
						>
							<label for="format-6/9">
								<img
									src="/wp-content/themes/id/images/classified/illustrations/illustation-6-9.png"
									width="56"
									height="70"
									alt=""
								/>
								<div class="label__container">
									<strong>6/9e de page</strong>
									<small>115 x 230 mm</small>
									<ul>
										<li>1800 caractères maximum</li>
										<li>6 photos possibles</li>
									</ul>
									<div class="price">
										<span>
											{{
												price(
													currentProfil,
													currentCategory,
													currentMode,
													"6/9"
												)
											}}
											€
											<small>TTC</small>
										</span>
									</div>
								</div>
								<!-- .label__container -->
								<input
									type="radio"
									name="format"
									id="format-6/9"
									value="6/9"
									v-model="format"
								/>
							</label>
						</div>
						<!-- .pa-block__col -->
						<div
							class="pa-block__col"
							:class="{ inactive: format != '9/9', active: format == '9/9' }"
						>
							<label for="format-9/9">
								<img
									src="/wp-content/themes/id/images/classified/illustrations/illustration-full.png"
									width="56"
									height="70"
									alt=""
								/>
								<div class="label__container">
									<strong>pleine page</strong>
									<small>210 x 270 mm</small>
									<ul>
										<li>2700 caractères maximum</li>
										<li>9 photos possibles</li>
									</ul>
									<div class="price">
										<span>
											{{
												price(
													currentProfil,
													currentCategory,
													currentMode,
													"9/9"
												)
											}}
											€
											<small>TTC</small>
										</span>
									</div>
								</div>
								<!-- .label__container -->
								<input
									type="radio"
									name="format"
									id="format-9/9"
									value="9/9"
									v-model="format"
								/>
							</label>
						</div>
						<!-- .pa-block__col -->
					</div>
					<!-- . format-selector__offer -->
				</div>
				<!-- .pa-block__col-container -->
				<!-- PROFLIB/RECRUITER / WEB -->
				<div class="pa-block__col-container" v-if="currentMode == 'web'">
					<div
						class="pa-block__col"
						:class="{
							inactive: format != 'simple',
							active: format == 'simple',
						}"
					>
						<label for="format-simple">
							<strong>Annonce web</strong>
							<ul>
								<li>Publication sur le site de l'Information Dentaire</li>
								<li v-if="isCurrentCategoryFree">
									<strong>
										Reprise sur le site internet Abcdent.pro
										<span class="text-primary">NOUVEAU</span>
									</strong>
								</li>
								<li>1500 caractères maximum</li>
								<li>durée de publication 1 mois</li>
							</ul>
							<div
								class="price"
								v-if="
									currentProfil == 'proflib' &&
									getCurrentCategory &&
									getCurrentCategory.free_category
								"
							>
								<span>
									Gratuit
									<!-- <small>Pour les demandes d'emploi</small> -->
								</span>
							</div>
							<div class="price" v-else>
								<span>
									{{
										price(currentProfil, currentCategory, currentMode, "simple")
									}}
									€
									<small>TTC</small>
								</span>
							</div>

							<input
								type="radio"
								name="format"
								id="format-simple"
								value="simple"
								v-model="format"
							/>
						</label>
					</div>
					<!-- .pa-block__col -->
					<div class="pa-block__col pa-block__col--inactive">
						<label for="format-pack">
							<img
								src="/wp-content/themes/id/images/classified/illustrations/illustration-pack.png"
								width="75"
								height="72"
								alt=""
							/>
							<strong>Packs, forfaits et abonnements</strong>
							<small
								>Vous souhaitez souscrire des packs, forfaits ou abonnements ?
							</small>
							<div class="price">
								Contactez Sabine Ikene au :<br />
								+33 (0)1 56 26 50 06
							</div>
						</label>
					</div>
					<!-- .pa-block__col -->
				</div>
				<!-- .pa-block__col-container -->
			</div>
			<!-- .pa-block__inner -->
		</div>
		<!-- .pa-block -->
	</div>
	<!-- .format-selector -->
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
	name: "format-selector",
	props: {
		showWarnings: {
			type: Boolean,
			default: false,
		},
	},
	data: function () {
		return {};
	},
	computed: {
		...mapGetters([
			"getPreset",
			"currentProfil",
			"currentCategory",
			"getCurrentCategory",
			"currentMode",
			"currentFormat",
			"isCurrentCategoryFree",
		]),
		...mapMutations(["setFormat"]),

		format: {
			get() {
				return this.currentFormat;
			},
			set(format) {
				this.$store.commit("setFormat", format);
				this.setMaxContentLength();
				this.setMaxMedias();
			},
		},
	},
	created() {
		if (!this.currentFormat && this.getPreset.format)
			this.$store.commit("setFormat", this.getPreset.format);
	},
	mounted() {
		if (this.currentMode == "web" && this.currentFormat === null)
			this.$store.commit("setFormat", "simple");
	},
	methods: {
		price(profil, category, mode, format) {
			return parseInt(this.$store.state.settings.formats[profil][mode][format]);
		},
	},
};
</script>

<style>
.text-primary {
	color: #d22e26;
	font-weight: 600;
	font-size: 1.125rem;
}
</style>
